import { sessionPrefix } from "./helpers";

export const messagesPath = (session: LightSessionInterface) => `${sessionPrefix(session)}/messages`;
export const newMessagePath = (session: LightSessionInterface) => `${sessionPrefix(session)}/messages/new`;
export const showMessagePath = (session: LightSessionInterface, message: MessageRef) =>
  `${sessionPrefix(session)}/messages/${message.id}`;
